/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Support_Reply_2Inputs */

const en_wb_support_reply_2 = /** @type {(inputs: Wb_Support_Reply_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would either time work for you?`)
};

const lv_wb_support_reply_2 = /** @type {(inputs: Wb_Support_Reply_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai kāds no šiem laikiem Jums derētu?`)
};

/**
* | output |
* | --- |
* | "Would either time work for you?" |
*
* @param {Wb_Support_Reply_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_support_reply_2 = /** @type {((inputs?: Wb_Support_Reply_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Support_Reply_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_support_reply_2(inputs)
	return en_wb_support_reply_2(inputs)
});